import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function Navbar() {
    const location = useLocation();

    return (
        <>
            <nav id="main-nav">
                <NavLink to={`projets${location.hash}`} 
                    className={({ isActive, isPending }) =>
                        isActive
                            ? "active"
                            : isPending
                                ? "pending"
                                : ""
                    }
                >
                    Projets
                </NavLink>
            </nav>
        </>
    )
}